<template>
  <b-card title="تسویه ها">
    <b-row>
      <div class="col-md-4" v-for="item in gatewayList" v-bind:key="item.id">
        <b-card no-body class="mt-2" style="cursor: pointer" @click="gotoShareAndSettlement(item.id)">
          <b-card-body>
            <div class="row align-items-center">
              <div class="col-md-4 col-sm-12">
                <div class="symbol symbol-lg-120">
                  <b-img style="height: auto" :src="item.fileUrl"></b-img>
                </div>
              </div>
              <div class="col-md-8 col-sm-12">
                <h4>{{ item.website_name }}</h4>
                <b-row>
                  <b-col>
                    {{ item.website }}
                  </b-col>
                </b-row>
              </div>
              <div class="col-sm-12">
                <div v-if="item.CanPaydBySharing" class="d-flex justify-content-between align-items-center p-3 mt-2"
                  style="background-color:#f3f6f9;border-radius:6px">
                  <strong class="font-weight-bold text-dark">موجودی تسهیم</strong>
                  <strong class="text-success">
                    {{ item.CanPaydBySharing.toLocaleString() }} ریال
                  </strong>
                </div>
                <div v-if="item.accounts && item.accounts.length" class="mt-3">
                  <div v-for="(account, index) in item.accounts" :key="index"
                    class="d-flex justify-content-between align-items-center p-2 mb-2"
                    style="background-color: #f3f6f9; border-radius: 6px">
                    <div class="font-weight-bold text-dark">
                      {{ account.label }}
                    </div>
                    <div class="text-success">
                      {{ Number(account.balance).toLocaleString() }} ریال
                    </div>
                  </div>
                  <div v-if="item.accounts && item.accounts.length"
                    class="d-flex justify-content-between align-items-center p-3 mt-2"
                    style="background-color:#e8f5f1;border-radius:6px">
                    <strong class="font-weight-bold text-dark">جمع کل حساب‌ها</strong>
                    <strong class="text-success">
                      {{ getTotalWithSharing(item).toLocaleString() }} ریال
                    </strong>
                  </div>
                </div>
                <div class="d-flex justify-content-between mt-3">
                  <div class="p-3">
                    {{ item.payment_priority == 1704 ? " مبلغ قابل تسویه: " : "موجودی در حال حاضر:" }}
                  </div>
                  <div class="d-flex justify-content-center align-items-center text-center text-light p-3"
                    style="background-color: #0d7d65; border-radius: 5px"
                    :class="item.payment_priority == 1704 ? 'bg-success' : 'bg-warning'">
                    {{ getTotalfinalSharing(item).toLocaleString()
                    }} ريال
                  </div>
                </div>
                <!-- <b-row class="mt-5">
                  <b-col class="p-3"> مبلغ در حال تسویه: </b-col>
                  <b-col
                    class="text-center text-dark p-3"
                    style="background-color: #f3f6f9; border-radius: 5px"
                  >
                    {{ Number(item.waiting).toLocaleString() }} ريال
                  </b-col>
                </b-row> -->
              </div>
            </div>
          </b-card-body>
        </b-card>
      </div>
    </b-row>
  </b-card>
</template>
<script>
import httpHelper from "../../helpers/httpHelper";
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import routesMap from '@/helpers/routesMap'
export default {
  name: "sharegateways",
  data() {
    return {
      gatewayList: [],
      routesMap,
    };
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [{ title: "تسویه حساب" }]);
    httpHelper.getData("share/gateways").then((res) => {
      this.gatewayList = res.result;
      this.gatewayList.forEach((gateway) => {
        httpHelper.getImage(gateway.logo).then((res) => {
          this.$set(gateway, 'fileUrl', res.result.url);
        });
      });
    });
  },
  methods: {
    gotoShareAndSettlement(id) {
      this.$router.push('share/' + id);
    },
    getAccountsTotal(item) {
      if (!item.accounts || !item.accounts.length) return 0
      return item.accounts.reduce((sum, acc) => {
        return sum + Number(acc.balance || 0);
      }, 0)
    },
    getTotalWithSharing(item) {
      const accountsTotal = this.getAccountsTotal(item)
      const baseAmount =
        item.payment_priority == 1704
          ? item.CanPaydBySharing
          : item.CanPaydTomorow
      return Number(baseAmount || 0) + accountsTotal
    },
    getTotalfinalSharing(item) {
      const finalTotal = this.getTotalWithSharing(item)
      return finalTotal - Number(item.in_progress_transfers_amount || 0)
    }
  }
};
</script>